import BlogHeaderTile from '@/assets/blogAssets/1/BlogHeaderTile1.jpg';
import BlogHeaderTile2 from '@/assets/blogAssets/2/BlogHeaderTile2.jpg';
import BlogHeaderTile3 from '@/assets/blogAssets/3/BlogHeaderTile3.jpg';
import BlogHeaderTile4 from '@/assets/blogAssets/4/BlogHeaderTile4.jpg';
import BlogHeaderTile5 from '@/assets/blogAssets/5/BlogHeaderTile5.jpg';
import BlogHeaderTile6 from '@/assets/blogAssets/6/BlogHeaderTile6.jpg';

export const BlogsData = [
  {
    id: '1',
    imageSrc: BlogHeaderTile,
    heading: 'Things to take care of while Applying for a Gold Loan',
    info: 'In India, gold has long been considered an investment. It is purchased for festivals, given as a present for important events ranging...',
    chip: 'Investments',
    url: '/blogs/gold-loan-from-home',
  },
  {
    id: '2',
    imageSrc: BlogHeaderTile2,
    heading: 'Top 5 benefits of a Gold Loan',
    info: ' Gold has sentimental importance in India as it represents riches and prosperity. In the country, gold decorations and jewellery are very popular...',
    chip: 'Investments',
    url: '/blogs/loan-emi-calculator-complete-guide',
  },
  {
    id: '3',
    imageSrc: BlogHeaderTile3,
    heading: 'What can you use your gold loans for?',
    info: 'A financial crunch or the need for extra finances is a situation not all of us are prepared for. However, there...',
    chip: 'Investments',
    url: '/blogs/gold-ornaments-for-the-highest-loan-value',
  },
  {
    id: '4',
    imageSrc: BlogHeaderTile4,
    heading: 'What is gold loan and how does it work?',
    info: 'Most Indians possess such a great passion for gold that we acquire between 25% and 33% of the worlds gold production every year...',
    chip: 'Investments',
    url: '/blogs/how-to-manage-gold-loan-repayment',
  },
  {
    id: '5',
    imageSrc: BlogHeaderTile5,
    heading: 'Advantages of Gold Loan over Personal Loan',
    info: "According to the World Gold Council, India's gold loan market has grown at a massive compound annual growth rate...",
    chip: 'Investments',
    url: '/blogs/gold-loan-interest-rate',
  },
  {
    id: '6',
    imageSrc: BlogHeaderTile6,
    heading: 'Bullet repayment in Gold Loans',
    info: 'The Indian gold loan market is expanding at a CAGR of 12.75% and is expected to reach Rs.6275.40 Bn by 2025 . Sometimes, we need to raise...',
    chip: 'Investments',
    url: '/blogs/instant-gold-loan',
  },
];
